// extracted by mini-css-extract-plugin
module.exports = {"chip":"Filters-module--chip--f711ff"};